export const CODIGO_NATUREZA_OPERACAO_PADRAO = '6.351';

export function obterNaturezaOperacaoPadrao(naturezasOperacoes) {
  const opcao = (naturezasOperacoes || []).find(
    it => it.valor && it.valor.startsWith(CODIGO_NATUREZA_OPERACAO_PADRAO)
  );
  return opcao ? { label: opcao.valor, value: opcao.chave } : null;
}
